import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let jobTypesSwiperWr = document.querySelectorAll('.home-areas-swiper-wr');
jobTypesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination, EffectFade],
      observer: true, // needs to calculate swiper size
      observeParents: true, // needs to calculate swiper size
      slidesPerView: 1.06,
      spaceBetween: 26,
      speed: 800,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      breakpoints: {  
        768: {
          slidesPerView: 1.8,
        },
        1024: {
          slidesPerView: 2.2,
        },
        1200: {
          slidesPerView: 2.4,
        }
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true,
      },
    });

    swiperObserver(swiper);
  }
});
